import { AddressSearch, CommonSearch, ForwarderListResult, ShipmentTypeListResult, ShipmentClassifyListResult, TruckTypeResult, GetReasonCodeByTypeResult } from './../model/common.model';
import { Vendor } from '../model/vendor.model';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { SelectItem, Country, Attachment, PaymentTerm } from '../model/common.model';
import { User } from '../model/user.model';
import { CustomerAddress } from '../model/customer.model';
import { BarCodeConfigH, BarcodeConfigModel, BarcodeConfigItem } from '../model/barcode.model';


const API_URL = environment.apiUrl;
const httpOptions = {
    headers: new HttpHeaders(
        {
            'Content-Type': 'application/json',
        }
    )
};

@Injectable()
export class SettingService {
    private Url = '';  // URL to web api
    currentUser: User;

    constructor(
        private http: HttpClient) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/settings';


    }

    getAdjustmentTypes(): Observable<SelectItem[]> {
        return this.http.get<SelectItem[]>(this.Url + "/adjustmenttypelist", httpOptions)
            .pipe(
                tap(response => {
                })
            );
    }
    getAdjustmentTypesDisplay(): Observable<SelectItem[]> {
        return this.http.get<SelectItem[]>(this.Url + "/GetStockAdjustmentTypeListWithDisplay", httpOptions)
            .pipe(
                tap(response => {
                })
            );
    }

    getStatusList(type: number): Observable<SelectItem[]> {
        return this.http.get<SelectItem[]>(this.Url + "/statuslist/" + type)
            .pipe(
                tap(response => {
                })
            );
    }

    getCountrys(): Observable<Country[]> {
        return this.http.get<Country[]>(this.Url + "/country/en", httpOptions)
            .pipe(
                tap(response => {
                })
            );
    }

    getPaymentTerms(): Observable<PaymentTerm[]> {
        return this.http.get<PaymentTerm[]>(this.Url + "/paymentterm", httpOptions)
            .pipe(
                tap(response => {
                })
            );
    }

    getTransportTypes(): Observable<SelectItem[]> {
        return this.http.get<SelectItem[]>(this.Url + "/transportype", httpOptions)
            .pipe(
                tap(response => {
                })
            );
    }


    getAttachmentList(id: number, data: Attachment): Observable<Attachment[]> {
        return this.http.post<Attachment[]>(this.Url + "/" + id.toString() + "/AttachList", data)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    uploadItemFileAttachment(id: number, data: FormData) {
        return this.http.post(this.Url + '/' + id.toString() + "/uploadAttachFile", data).pipe(
            tap((res: any) => this.log(res)),
            catchError(this.handleError<any>('uploadItemFileAttachment'))
        );
    }

    deleteItemFileAttachment(itemID: number, atth: Attachment) {
        return this.http.post(this.Url + '/' + itemID.toString() + "/deleteAttachFile", atth, httpOptions).pipe(
            tap((res: any) => this.log(res)),
            catchError(this.handleError<any>('deleteItemFileAttachment'))
        );
    }
    getLocationTypeList(): Observable<SelectItem[]> {
        return this.http.get<SelectItem[]>(this.Url + "/LocationType", httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetCustomerAddressByType(data: AddressSearch): Observable<CustomerAddress[]> {
        return this.http.post<CustomerAddress[]>(this.Url + "/GetCustomerAddressByType", data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetReasonCodeByType(data: CommonSearch): Observable<GetReasonCodeByTypeResult[]> {
        return this.http.post<GetReasonCodeByTypeResult[]>(this.Url + "/GetReasonCodeByType", data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }


    GetForwarderList(data: CommonSearch): Observable<ForwarderListResult[]> {
        return this.http.post<ForwarderListResult[]>(this.Url + "/GetForwarderList", data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetShipmentTypeList(data: CommonSearch): Observable<ShipmentTypeListResult[]> {
        return this.http.post<ShipmentTypeListResult[]>(this.Url + "/GetShipmentTypeList", data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetShipmentClassifyList(data: CommonSearch): Observable<ShipmentClassifyListResult[]> {
        return this.http.post<ShipmentClassifyListResult[]>(this.Url + "/GetShipmentClassifyList", data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetTruckType(data: CommonSearch): Observable<TruckTypeResult[]> {
        return this.http.post<TruckTypeResult[]>(this.Url + "/GetTruckType", data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetBarcodeConfigList(): Observable<BarCodeConfigH[]> {
        return this.http.get<BarCodeConfigH[]>(this.Url + "/GetBarcodeConfigList", httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetBarcodeConfigItemmByID(id: number): Observable<BarcodeConfigItem[]> {
        return this.http.get<BarcodeConfigItem[]>(this.Url + "/GetBarcodeConfigItemByID/" + id.toString(), httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    UpdateBarcode(data: BarcodeConfigModel): Observable<any> {
        return this.http.post<any>(this.Url + "/UpdateBarcode", data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }


    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    /** Log a ScgCompanyService message with the MessageService */
    private log(message: string) {
        console.log(message);
        // this.messageService.add('ScgCompanyService: ' + message);
    }


}


// WEBPACK FOOTER //
// ./src/app/services/setting.service.ts